//CustomSelect in base folder
import React from "react";
import { Dropdown } from "primereact/dropdown";

const BaseSelect = ({
    styleClass = "",
    value = null,
    label,
    name,
    selectKey,
    filter = false,
    showClear = false,
    inputId,
    options,
    onChange,
    disabled = false
}: any) => {
    return (
        <div className="mt-7 relative">
            <span className="p-float-label">
                <Dropdown
                    name={name}
                    inputId={inputId}
                    value={value}
                    options={options}
                    onChange={(e) => onChange(e.value)}
                    optionLabel={selectKey}
                    className={`${styleClass} w-full text-left border  ${
                        !value ? "!bg-[#F9FAFC]" : "!bg-white"
                    }`}
                    showClear={showClear}
                    filter={filter}
                    disabled={disabled}
                />
                <label htmlFor={inputId}>{label}</label>
            </span>
        </div>
    );
};
export default BaseSelect;
